function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { BusquedaCV } from '../../model/busqueda-cv';
var ReglaValidaReqDocComponentCtrl = /*#__PURE__*/function () {
  ReglaValidaReqDocComponentCtrl.$inject = ["$scope", "$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function ReglaValidaReqDocComponentCtrl($scope, $element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, ReglaValidaReqDocComponentCtrl);
    _defineProperty(this, "dirty", false);
    _defineProperty(this, "edit", {
      estado: null,
      doc: null,
      formid: null,
      busqueda: null,
      pregFilter: null
    });
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
    this.edit.busqueda = new BusquedaCV();
    this.edit.busqueda.setMaxCondiciones(1);
  }
  return _createClass(ReglaValidaReqDocComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[ReglaValidaReqDocComponentCtrl] onInit');
      this.estadosList = this.reglaVal.estadosList;
      this.tiposDocGruposList = this.reglaVal.tiposDocGruposList;
      this.seleccionFormList = this.reglaVal.formsList;
      if (this.reglaVal.rule.idreqdoc) {
        if (this.reglaVal.rule.estado) {
          this.edit.estado = this.reglaVal.rule.estado;
        }
        if (this.reglaVal.rule.tipodoc) {
          this.edit.doc = this.reglaVal.rule.tipodoc;
        }
        if (this.reglaVal.rule.idform) {
          this.edit.formid = this.reglaVal.rule.idform;
          this.seleccionaForm(this.reglaVal.rule);
        }

        // si hay idquestion, definir la condición
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this = this;
      // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 100)

      this.$timeout(function () {
        var textarea = _this.$element.find('.materialize-textarea');
        if (textarea && textarea[0]) M.textareaAutoResize(textarea);
      }, 200);
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;
      var rule = Object.assign({}, this.reglaVal.rule);
      rule.estado = this.edit.estado;
      rule.tipodoc = this.edit.doc;
      rule.idform = this.edit.formid;
      if (this.edit.busqueda.condiciones.length) {
        this.edit.busqueda.condiciones[0].condicionToFilterReqDoc(rule);
      }
      this.AccesoDatos.Documentacion_CLIENT.actualizaReglaValidacionDocObligatoria(rule).then(function (ruleResponse) {
        _this2.reglaVal.actualiza(ruleResponse);
        _this2.dirty = false;
      });
    }
  }, {
    key: "cambioForm",
    value: function cambioForm() {
      this.seleccionaForm();
      this.reglaVal.$dirty = true;
    }
  }, {
    key: "seleccionaForm",
    value: function seleccionaForm(rule) {
      var _this3 = this;
      if (!this.edit.formid) return;
      this.edit.busqueda.selFormId(this.edit.formid);
      this.reglaVal.pregsStore.pregsParaFormulario(this.edit.formid).then(function (pregsList) {
        _this3.edit.busqueda.pregslist = pregsList;
        _this3.edit.busqueda.resetCondiciones();
        _this3.$timeout(function () {
          var c = _this3.edit.busqueda.nuevaCondicionPregunta();
          if (rule !== null && rule !== void 0 && rule.idquestion) c.filterReqDocToWhere(rule);
        }, 100);
      });
    }
  }]);
}();
angular.module('candidato').component('reglaValidaReqDoc', {
  bindings: {
    reglaVal: '<'
  },
  controller: ReglaValidaReqDocComponentCtrl,
  // templateUrl: "regla-valida-req-doc.component.html",
  template: require('./regla-valida-req-doc.component.html')
});